import { assert } from '../../lib/assert-sidecar'
import { distanceUtil } from '../../lib/distanceUtil-sidecar'
import { common } from '../../main/common-sidecar'
import { voyageBullets } from './voyageBullets-sidecar'
import { EVoyageCarryableType } from './voyageCarryable'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'

export function update(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.weaponState
  assert.notNil(d)

  if (obj.isDead) {
    return
  }

  d.reloadTimer += ds

  let reloadTime = d.data.reloadTime
  if (
    obj.carryable &&
    obj.carryable.type === EVoyageCarryableType.BattleRifle
  ) {
    reloadTime *= 0.33
  }

  if (d.reloadTimer > reloadTime) {
    d.reloadTimer -= reloadTime
    let tgs = voyageCrew.getAll()
    let closestTarget: IVoyageCrew | null = null
    let closestDistance = d.data.maxDistance
    for (let i = 0; i < tgs.length; i++) {
      let target = tgs[i]
      if (target.isDead || target.isDying) {
        continue
      }
      if (target === obj) {
        continue
      }
      if (target.team === -1) {
        continue
      }
      if (target.team === obj.team) {
        continue
      }

      let dist = distanceUtil.distanceNormalXY(obj, target)
      if (dist < closestDistance) {
        closestDistance = dist
        closestTarget = target
      }
    }
    if (closestTarget) {
      // Fire at!
      voyageBullets.create(obj.team, d.data, obj, closestTarget, 12)

      if (obj.team === 0) {
        voyageSounds.playShootCrewGun()
      } else {
        voyageSounds.playShootAlienGun()
      }
    }
  }
}
